<template>
    <!-- <div class="wbs-dividing-line" :style="dividingLineStyle[depth]"> -->
    <!-- <div class="wbs-dividing-line"> -->
        <tr class="wbs-row wbs-dev-methodology-row">
            <div style="display:flex; height:2.3rem">
                <td style="display:flex;">
                    {{getDepth()}}
                    <button class="wbs-fold-button" :class="{'show-fold-button' : hasChildren}" @click="toggleFolded">
                        <b-icon :icon="isExpanded ? 'caret-down-fill' : 'caret-right-fill'"></b-icon>
                    </button>
                    <!-- <strong>{{ devMethodology.step }}</strong>
                    <span v-if="subChatterCount > 0" class="sub-chatter-count">
                        {{ subChatterCount }}
                    </span> -->
                    <span class="wbs-title">
                        <strong>{{ devMethodology.step }}</strong>
                        <!-- <span v-if="subChatterCount > 0" class="sub-chatter-count">
                            {{ subChatterCount }}
                        </span> -->
                    </span>
                </td>
                
                <td>
                    <div class="progress-wrapper">
                        <progress-bar
                    :toDo="devMethodology.toDoChatterCount"
                    :inProgress="devMethodology.inProgressChatterCount"
                    :done="devMethodology.doneChatterCount"
                    :cancelled="devMethodology.cancelledChatterCount"
                    :closed="devMethodology.closedChatterCount"/>
                    </div>
                </td>
                <td></td>
            </div>
            
            <!-- <td>
                <status-badge :status="devMethodology.status">{{ formatStatusLabel(devMethodology.status) }}</status-badge>
            </td> -->
            <template v-if="isExpanded" v-for="chatter in devMethodology.chatterList" >
                <chatter-row :chatter="chatter" :depth="depth + 1" :key="chatter.chatId"/>
            </template>
            <template v-if="depth < 5 && isExpanded" v-for="nextStep in devMethodology.children" >
                <dev-methodology-row :devMethodology="nextStep" :depth="depth + 1" :key="nextStep.id"/>
            </template>
        </tr>

    <!-- </div> -->
</template>
<script>
import ChatterRow from "@/components/chatter/wbs/ChatterRow.vue";
import DevMethodologyRow from "@/components/chatter/wbs/DevMethodologyRow.vue";
import StatusBadge from "./StatusBadge.vue";
import ProgressBar from "./ProgressBar.vue";

export default {
    name:"DevMethodologyRow",
    props: {
        devMethodology: {type:Object},
        depth : {type : Number}
    },
    components: {
        ChatterRow,
        DevMethodologyRow,
        StatusBadge,
        ProgressBar
    },
    created() {
        // 하위 Chatter 개수
        this.subChatterCount = this.devMethodology.chatterList.length;
    },
    computed : {
        hasChildren() {
            return this.devMethodology.children.length > 0 || this.devMethodology.chatterList.length > 0;
            // return this.devMethodology.children.length > 0;       
        },
        isExpanded() {
            return this.$store.getters["wbs/getExpanded"](this.devMethodology.id);
        }
    },
    data() {
        return {
            subChatterCount : 0,
        }
    },
    methods: {
        getDepth() {
            let depthStr = "";
            for(let i = 0; i < this.depth; i++) {
                depthStr += '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0';
            }

            return depthStr;
        },
        toggleFolded(event) {
            event.stopPropagation();
            // this.$set(this.devMethodology, 'expanded', !this.devMethodology.expanded);
            this.$store.commit("wbs/setExpanded", {id:this.devMethodology.id, isExpanded: !this.isExpanded});
        },
        
        formatStatusLabel(text) {
            if(!text) return;
            const words = text.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
            return words.join(" ");
        },
    },
    filters: {
        formatDate(dateStr) {
            if(dateStr != '' && dateStr != null) {
                return dateStr.substring(2);
            } else {
                return dateStr
            }
        }
    }
}

</script>
<style>
* {
    box-sizing: border-box !important;
}
.wbs-row {
    display: flex;
    width: 100%;
    margin: 0.3rem 0;
    /* border-bottom: 2px solid #F6F6FA; */
    box-sizing: border-box;
    /* background-color: #FFF; */
    font-size: 1rem;
    min-height: 2.3rem;
}
.wbs-row.wbs-dev-methodology-row,
.wbs-row.chatter-row {
    flex-direction: column;
}
/* .wbs-row:hover {
    background-color: #F6F6FA;
} */
.wbs-row td {
    flex: 1;
}
.wbs-row .wbs-fold-button {
    background-color: transparent;
    border: none;
    visibility: hidden;
    height: 100%;
}
.wbs-row .show-fold-button {
    visibility: visible;
}
.wbs-row td:first-child {
    flex:3;
    overflow: hidden;
}
.wbs-row td:not(:first-child) {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.wbs-row .wbs-duration {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.wbs-row .wbs-duration span {
    width: 40%;
}

.wbs-row .progress-wrapper {
    width: 80%;
    height: 70%;
    display: flex;
    justify-content: start ;
    background-color: #D8E7FF;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
}
.wbs-row .progress-wrapper .progress-bar {
    background-color: #142459;
    height: 100%;
    width: 50%;
}

.wbs-row .progress-wrapper .progress-label {
    color: white;
    position: absolute;
    font-weight: bold;
    height: 100%;
    width: 100%;
    top: 50%;
    left:50%;
    transform:translate(-50%, -50%);
}

.wbs-title {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>